export default __webpack_public_path__ + "locales/ar-SA/BackupCodesDialog.json?hash=b59fbb938376cdf7cccbcb16f90337ca";